import { AdminRoutes } from '@shared/routes';
import { Alert, Button } from 'flowbite-react';
import { Link, useLocation } from 'react-router-dom';

const AuthError = () => {
  const location = useLocation();
  const error = location.state?.error || 'Произошла неизвестная ошибка';

  return (
    <div className="flex flex-col gap-4">
      <Alert color="failure">
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold">Ошибка авторизации</h3>
          <p className="text-sm">{error}</p>
        </div>
      </Alert>

      <div className="flex justify-center">
        <Link to={AdminRoutes.auth.path}>
          <Button color="gray" outline>
            Вернуться к авторизации
          </Button>
        </Link>
      </div>
    </div>
  );
};

export { AuthError };
